

import React from "react";

export const FileSvg = (props) => {
	const { width, height } = props;
	return (
		<svg width={width ?? "120"} height={height ?? "120"} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 303.188 303.188" >
			<polygon fill="#E8E8E8" points="219.821,0 32.842,0 32.842,303.188 270.346,303.188 270.346,50.525" />
			<rect x="92.817" y="166.37" fill="#D1D3D3" width="49.543" height="12.865" />
			<rect x="92.817" y="141.729" fill="#D1D3D3" width="107.543" height="12.865" />
			<rect x="92.817" y="117.087" fill="#D1D3D3" width="117.551" height="12.865" />
			<rect x="92.817" y="92.445" fill="#D1D3D3" width="82.209" height="12.865" />
			<rect x="92.817" y="67.804" fill="#D1D3D3" width="117.551" height="12.865" />
			<polygon fill="#A4A9AD" points="227.64,25.263 32.842,25.263 32.842,0 219.821,0" />
			<polygon fill="#D1D3D3" points="219.821,50.525 270.346,50.525 219.821,0" />
		</svg>
	)
}